import { render, staticRenderFns } from "./KendaraanRescueHarianPage.vue?vue&type=template&id=3b926ba6"
import script from "./KendaraanRescueHarianPage.vue?vue&type=script&lang=js"
export * from "./KendaraanRescueHarianPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports